import { FC, useState } from 'react';

import RequestInfoMapDialog from '@components_iqfu/dashboard/dialog/request_info_map/RequestInfoMapDialog';

import styles from './RequestInfoMapButton.module.scss';

type RequestInfoMapButtonType = {
  sellingContractId: number;
  hasMap: boolean;
};

const RequestInfoMapButton: FC<RequestInfoMapButtonType> = ({ sellingContractId, hasMap }) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [hasCompletedRequest, setHasCompletedRequest] = useState(false);

  const handleClose = () => setIsModalOpened(false);

  const buttonText = !hasMap ? '図面なし' : hasCompletedRequest ? '取得依頼済み' : '図面';
  return (
    <>
      <button
        disabled={isProcessing}
        className={`${styles.contract_info_map_request_button} ${hasMap ? '' : styles.is_disabled} ${
          hasCompletedRequest ? styles.is_disabled : ''
        }`}
        onClick={() => setIsModalOpened(true)}
      >
        {buttonText}
      </button>

      <RequestInfoMapDialog
        onClose={handleClose}
        sellingContractId={sellingContractId}
        processingState={{ isProcessing, setIsProcessing }}
        completeRequestState={{ hasCompletedRequest, setHasCompletedRequest }}
        open={isModalOpened}
        fullWidth={false}
      />
    </>
  );
};

export default RequestInfoMapButton;
